var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataCatalog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "192px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Other/logo/colored/EthicsLine Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.5906059%",
    y1: "78.8871746%",
    x2: "79.3721548%",
    y2: "20.0983239%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#467EC0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9AD2",
    offset: "49.1568917%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C3DE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Other/logo/colored/EthicsLine-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    x: 0,
    y: 0,
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,100 L56,109 L90,109 C94.418278,109 98,112.581722 98,117 L98,156 C98,160.418278 94.418278,164 90,164 L26,164 C21.581722,164 18,160.418278 18,156 L18,108 C18,103.581722 21.581722,100 26,100 L50,100 Z M144,100 C146.209139,100 148,101.790861 148,104 L147.99992,132.682795 C152.660731,134.330118 156,138.775095 156,144 C156,150.627417 150.627417,156 144,156 C138.775467,156 134.330751,152.661207 132.683147,148.000916 L110,148 C107.790861,148 106,146.209139 106,144 C106,141.790861 107.790861,140 110,140 L132.682795,140.00008 C133.887812,136.590694 136.589836,133.888456 139.999084,132.683147 L140,104 C140,101.790861 141.790861,100 144,100 Z M126,28 L132,37 L166,37 C170.418278,37 174,40.581722 174,45 L174,84 C174,88.418278 170.418278,92 166,92 L102,92 C97.581722,92 94,88.418278 94,84 L94,36 C94,31.581722 97.581722,28 102,28 L126,28 Z M48,36 C53.2245331,36 57.6692493,39.3387931 59.3168535,43.9990843 L82,44 C84.209139,44 86,45.790861 86,48 C86,50.209139 84.209139,52 82,52 L59.3172055,51.9999199 C58.1121877,55.4093062 55.4101643,58.1115442 52.0009157,59.3168535 L52,88 C52,90.209139 50.209139,92 48,92 C45.790861,92 44,90.209139 44,88 L44.0000801,59.3172055 C39.3392688,57.6698824 36,53.2249052 36,48 C36,41.372583 41.372583,36 48,36 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCatalog);
export default __webpack_public_path__ + "2113976a35ce812c8806ff090bdba13a.svg";
export { ForwardRef as ReactComponent };